module.exports = __webpack_public_path__ + "static/img/number_03@2x.8813377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_03@2x.png
// module id = kIwe
// module chunks = 0